import { graphql } from "gql/apollo";

export const UpdateIntegrationPassword = graphql(/* GraphQL */ `
	mutation UpdateGenetecIntegrationPasswordByGID(
		$params: UpdateGenetecIntegrationPasswordByGIDParams!
	) {
		updateGenetecIntegrationPasswordByGID(params: $params) {
			error {
				message
			}
			success
		}
	}
`);
